import { useState } from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import { Box } from '@mui/material';
import { NoImage } from '@/components/global/fields/NoImage';

const emptyLogoSx = {
    minWidth: '72px',
    width: '72px',
    minHeight: '48px',
    height: '48px',
    '& svg': {
        width: '24px',
        height: '24px',
    },
};

export const RetailChainLogoField = ({ width = 72, height = 48, column = false }) => {
    const record = useRecordContext();
    const [failed, setFailed] = useState(false);
    const apiUrl = import.meta.env.VITE_API_URL;
    const src = record?.logo || (record?.id && record?.currentLogo ? `${apiUrl}/retail-chain/logo/${record.id}` : '');
    const hasLogo = Boolean(record?.currentLogo || record?.logo);

    if (!hasLogo || !src || failed) {
        if (column) {
            return <NoImage />;
        }

        return <NoImage sx={{ ...emptyLogoSx, minWidth: width, width, minHeight: height, height }} />;
    }

    if (column) {
        return (
            <Box
                component='img'
                alt={record?.name || ''}
                src={src}
                sx={{ width: 100, maxWidth: 200, maxHeight: 200, height: 'auto', objectFit: 'contain' }}
                onError={() => setFailed(true)}
            />
        );
    }

    return <Box component='img' alt={record?.name || ''} src={src} sx={{ width, height, objectFit: 'contain' }} onError={() => setFailed(true)} />;
};

RetailChainLogoField.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    column: PropTypes.bool,
};
